import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';

type PropTypes = {
  close: () => void;
  handleAddTeamClick: (teamName: string) => void;
  open: boolean;
};

export const LeagueAddTeamDialog = ({
  close,
  handleAddTeamClick,
  open,
}: PropTypes) => {
  const theme = useTheme();
  const [teamName, setTeamName] = useState('');

  return (
    <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
      <DialogContent>
        <Stack spacing={1}>
          <TextField
            value={teamName}
            placeholder="Team name"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setTeamName(event.target.value);
            }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} fullWidth>
          Cancel
        </Button>
        <Button onClick={() => handleAddTeamClick(teamName)} fullWidth>
          Add Team
        </Button>
      </DialogActions>
    </Dialog>
  );
};
